const keyMapping = {
  "Accounts Payable": "__AccountsPayable",
  "Accounts Receivable": "__AccountsReceivable",
  "Advertisement Expense": "__AdvertisementExpense",
  "Cash in Banks": "__CashInBanks",
  "Cash in Transit": "__CashInTransit",
  "Cash on Hand": "__CashOnHand",
  "Deposit Account": "__DepositAccount",
  "Donation Expense": "__DonationExpense",
  "Entertainment Expense": "__EntertainmentExpense",
  "Insurance Expense": "__InsuranceExpense",
  "Long-Term Debt Payable": "__LongTermDebtPayable",
  "Merchandise Inventory": "__MerchandiseInventory",
  "Notes Payable": "__NotesPayable",
  "Notes Receivable": "__NotesReceivable",
  "Payroll Expense": "__PayrollExpense",
  "Postage Expense": "__PostageExpense",
  "Purchase Expenses": "__PurchaseExpenses",
  Purchases: "__Purchases",
  "Rent Expense": "__RentExpense",
  "Repairs and Maintenance": "__RepairsAndMaintenance",
  "Sales Revenue": "__SalesRevenue",
  "Service Revenue": "__ServiceRevenue",
  "Shipping Expense": "__ShippingExpense",
  "Short-Term Debt": "__ShortTermDebt",
  "Supplies Expense": "__SuppliesExpense",
  Taxes: "__Taxes",
  "Travelling Expense": "__TravellingExpense",
  "Utilities Expense": "__UtilitiesExpense",
  "Unearned Revenue": "__UnearnedRevenue",
  Other: "__Other"
}

var mixin = {
  methods: {
    getAccountTranslatedName(name) {
      if (Object.keys(keyMapping).includes(name)) {
        return this.$t("Accounts." + keyMapping[name])
      } else {
        return name
      }
    }
  }
}

export { mixin }
